import { PureComponent, type ReactElement } from 'react';

import classNames from 'classnames';

import ICONS from '../../../icons/constants';
import Icon from '../../../icons/icon';
import type { ValueComponentProps } from '../../../ui/select_field/types';

import mixins from '../../../styles/core/mixins.module.css';
import styles from './select_field_color_value.module.css';

class SelectFieldDefaultValue extends PureComponent<ValueComponentProps> {
  handleDeleteClick = (): void => {
    const { onDelete, value, isDisabled } = this.props;
    if (isDisabled) {
      return;
    }
    if (onDelete) {
      onDelete(value);
    }
  };

  render(): ReactElement {
    const { isDisabled, value } = this.props;
    return (
      <div
        className={classNames(styles.root, { [styles.disabled]: isDisabled })}
        role="listitem"
      >
        {!isDisabled && (
          <button
            type="button"
            className={classNames(styles.delete, mixins.reset_button)}
            onClick={this.handleDeleteClick}
          >
            <Icon icon={ICONS.CrossMark} size={10} />
          </button>
        )}
        <div
          className={styles.color}
          style={{ backgroundColor: value.value }}
        />
      </div>
    );
  }
}

export default SelectFieldDefaultValue;
